export default __webpack_public_path__ + "static/media/nav-arrow.bd36b6d3.svg";